import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: { main: '#FFC107', contrastText: '#1a1306' },
    background: { default: '#08080a', paper: '#17171b' },
    text: { primary: '#f4f4f5', secondary: '#8a8a92' },
  },
  typography: {
    fontFamily: '"Inter", "Sora", -apple-system, system-ui, sans-serif',
    h1: { fontFamily: '"Sora", "Inter", sans-serif', fontWeight: 600 },
    h2: { fontFamily: '"Sora", "Inter", sans-serif', fontWeight: 500 },
    h3: { fontFamily: '"Sora", "Inter", sans-serif', fontWeight: 500 },
    h4: { fontFamily: '"Sora", "Inter", sans-serif', fontWeight: 500 },
    h5: { fontFamily: '"Sora", "Inter", sans-serif', fontWeight: 500 },
    h6: { fontFamily: '"Sora", "Inter", sans-serif', fontWeight: 500 },
    button: { textTransform: 'none', fontWeight: 500 },
  },
  shape: { borderRadius: 12 },
});

export default theme;
